import { styled } from "@mui/material/styles";

const TableStyles = styled("div")(
  ({ theme }) => `
    width: 100%;

    @media (max-width: 600px) {
    display: none;
}

    .table-head {
      font-family: Lexend;
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      color: #959595;
      text-transform: uppercase;
      padding: 0px 20px;
      border-bottom: none!important;
    }

    .table-container {
      position: relative;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      scrollbar-width: none;
      overflow-x: auto;
      overflow-y: auto;
    }

    .table-paper {
      width: 100%;
      border-radius: 0px;
      box-shadow: none;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    .table-head-class {
      height: 60px;
      max-height: 60px;
    }

    .table-body {
      position: absolute;
      width: 100%;
      padding-top: 20vh;
    }

    .table-data {
      border-bottom: none !important;
    }

    .pagination-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 24px;
      position: sticky;
      bottom: 0;
      background: white;
      width: 100%;
      min-width: 100%;
      box-sizing: border-box;
      z-index: 10;
      margin: 0;
      flex-shrink: 0;
      left: 0;
      right: 0;
    }

    .pagesize {
      display: flex;
      gap: 8px;
      align-items: center;
      color: ${theme.palette.customColor.placeholder};
      font-weight: 500;
      font-size: 15px;
    }

    .select-input {
      height: 38px;
      width: 78px;
      & .MuiOutlinedInput-notchedOutline {
        border-color: #F0F0F0;
      }
      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: #F0F0F0;
      }
      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: #F0F0F0;
      }
    }

     .my-table-data {
      font-family: Lexend;
      font-weight: 400;
      font-size: 14px;
      line-height: 17.5px;
      color: #050505;
      height: 60px;
      max-height: 60px;
      padding: 0px 20px;
      width: fit-content;
      max-width: 180px !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      border-top: 1px solid #F0F0F0 !important;
      border-bottom: none !important;
    }
     .my-table-data2 {
      font-family: Lexend;
      font-weight: 400;
      font-size: 14px;
      line-height: 17.5px;
      color: #050505;
      height: 60px;
      max-height: 60px;
      padding: 0px 20px;
      width: fit-content;
      max-width: 180px !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      border-bottom: none !important;
    }

    .border-top {
     border-top: 1px solid #F0F0F0 !important;
     border-bottom: none !important;
     }

        .beige-color {
      color: #A78D78;
    }
          .table-cell {
      border: none !important;
    }


    .table-head-class1 {
      height: 60px;
      max-height: 60px;
      max-width: 100px;
    }

    .padding-0 {
      padding: 0px !important;
    }

    .collapse-container {
      padding-bottom: 0;
      padding-top: 0;
      padding: 0 8%;
      border-bottom: none;
    }

    .icon-button {
      padding: 0;
    }

    .order-amount-box {
      background-color: #F0F0F0;
      padding: 8px 24px;
      margin-bottom: 18px;
    }

    .order-amount-text {
      color: #656565;
      font-family: Lexend;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
    }

    .amount-box {
      background-color: #F0F0F0;
      height: 33px;
      margin-bottom: 18px;
    }

    .pending-amount-box {
      background-color: #F0F0F0;
      padding: 8px 24px;
      padding-left: 4px;
      margin-bottom: 18px;
    }

    .pending-amount-text {
      font-family: Lexend;
      font-size: 14px;
      line-height: 16px;
      padding: 0 10.2%;
    }
`
);

export { TableStyles };

